import React, { Suspense, useContext, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Loading from './components/Loading';
import ProtectedRoute from './protectedRoutes/ProtectedRoute';
import AdminRoute from './protectedRoutes/AdminRoute';
import MetasRoute from './protectedRoutes/MetasRoute';
import VRVARoute from './protectedRoutes/VRVARoute';
import VestuarioRoute from './protectedRoutes/VestuarioRoute';
import OuvidoriaRoute from './protectedRoutes/OuvidoriaRoute';
import OuvidoriaConsultaRoute from './protectedRoutes/OuvidoriaConsultaRoute';
import CipaRoute from './protectedRoutes/CipaRoute';
import CapsRoute from './protectedRoutes/CapsRoute';
import MdiRoute from './protectedRoutes/MdiRoute';
import PesquisaRoute from './protectedRoutes/PesquisaRoute';
import InscricaoAdminRoute from './protectedRoutes/InscricaoAdminRoute';
import GestaoDeLeitosRoute from './protectedRoutes/GestaoDeLeitosRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Chamados from './pages/Chamados';
import ChamadosNovo from './pages/ChamadosNovo';
import EsqueciSenha from './pages/EsqueciSenha';
import EsqueciSenhaOk from './pages/EsqueciSenhaOk';
import ResetarSenha from './pages/ResetarSenha';
import Chamado from './pages/Chamado';
import Admin from './pages/Admin';
import Usuarios from './pages/Admin/Usuarios';
import UsuariosNovo from './pages/Admin/Usuarios/Novo';
import UsuariosEditar from './pages/Admin/Usuarios/Editar';
import PageNotFound from './pages/PageNotFound';

import { UserContext } from './context/UserContext';
import { CapsProvider } from './context/CapsContext';
import { CapsDocsProvider } from './context/CapsDocsContext';
import { MonitoramentoProvider } from './context/MonitoramentoContext';
import { AcoesTerritoriaisProvider } from './context/AcoesTerritoriais';

const Confirmacao = lazy(() => import('./pages/Confirmacao'));
const Graficos = lazy(() => import('./pages/Graficos'));
const Metas = lazy(() => import('./pages/Metas'));
const VRVA = lazy(() => import('./pages/VRVA'));
const GestaoIndicador1 = lazy(() => import('./pages/Metas/Gestao/Indicador1'));
const GestaoIndicador2 = lazy(() => import('./pages/Metas/Gestao/Indicador2'));
const Vestuario = lazy(() => import('./pages/Vestuario'));
const Ouvidoria = lazy(() => import('./pages/Ouvidoria'));
const OuvidoriaAdd = lazy(() => import('./pages/OuvidoriaAdd'));
const OuvidoriaEdit = lazy(() => import('./pages/OuvidoriaEdit'));
const OuvidoriaShow = lazy(() => import('./pages/OuvidoriaShow'));
const CipaaList = lazy(() => import('./pages/CipaaList'));
const CipaaApuracao = lazy(() => import('./pages/CipaaApuracao'));
const CipaaApresentacao = lazy(() => import('./pages/CipaaApresentacao'));
const CipaaVotacao = lazy(() => import('./pages/CipaaVotacao'));
const ReducaoForm = lazy(() => import('./pages/ReducaoForm'));
const ReducaoList = lazy(() => import('./pages/ReducaoList'));
const ReducoesList = lazy(() => import('./pages/Reducao/ReducoesList'));
const NovaAcao = lazy(() => import('./pages/Reducao/NovaAcao'));
const AcaoForm = lazy(() => import('./pages/Reducao/AcaoForm'));
const AcoesUsuario = lazy(() => import('./pages/Reducao/AcoesUsuario'));
const ReducaoTerritorio = lazy(() => import('./pages/ReducaoTerritorio'));
const ReducaoMapaTerritorio = lazy(() => import('./pages/ReducaoMapaTerritorio'));
const ReducaoDeDanos = lazy(() => import('./pages/ReducaoDeDanos'));
const PessoasAtendidas = lazy(() => import('./pages/GraficosAT/PessoasAtendidas.js'));
const Atendimentos = lazy(() => import('./pages/GraficosAT/Atendimentos.js'));
const AcoesRealizadas = lazy(() => import('./pages/GraficosAT/AcoesRealizadas.js'));
const Encaminhamentos = lazy(() => import('./pages/GraficosAT/Encaminhamentos.js'));
const Demandas = lazy(() => import('./pages/GraficosAT/Demandas.js'));
const UnidadeRef = lazy(() => import('./pages/GraficosAT/UnidadeRef.js'));
const PerfilPop = lazy(() => import('./pages/GraficosAT/PerfilPop.js'));
const CCCNForm = lazy(() => import('./pages/CCCN/Form'));
const CCCNList = lazy(() => import('./pages/CCCN/List'));
const CCCNDocsList = lazy(() => import('./pages/CCCN/Docs/List/index.js'));
const CCCNDocsForm = lazy(() => import('./pages/CCCN/Docs/Form/index.js'));
const PDFView = lazy(() => import('./components/pdfViewer.js'));
const Caps = lazy(() => import('./pages/Caps'));
const CapsAdd = lazy(() => import('./pages/CapsAdd'));
const CapsShow = lazy(() => import('./pages/CapsShow'));
const CapsEdit = lazy(() => import('./pages/CapsEdit'));
const CapsMapa = lazy(() => import('./pages/CapsMapa'));
const CapsDocs = lazy(() => import('./pages/CapsDocs'));
const CapsDocsForm = lazy(() => import('./pages/CapsDocsForm'));
const MonitoramentoList = lazy(() => import('./pages/Monitoramento/List'));
const MonitoramentoForm = lazy(() => import('./pages/Monitoramento/Form'));
const Pesquisa = lazy(() => import('./pages/Pesquisa'));
const PesquisaGrafico = lazy(() => import('./pages/PesquisaGrafico'));
const PesquisaGraficos = lazy(() => import('./pages/PesquisaGraficos'));
const DocValidation = lazy(() => import('./pages/DocValidation'));
const Inscricao = lazy(() => import('./pages/Inscricao'));
const InscricaoLogin = lazy(() => import('./pages/Inscricao/InscricaoLogin'));
const InscricaoCadastro = lazy(() => import('./pages/Inscricao/InscricaoCadastro'));
const InscricaoEsqueciSenha = lazy(() => import('./pages/Inscricao/InscricaoEsqueciSenha'));
const InscricaoResetarSenha = lazy(() => import('./pages/Inscricao/InscricaoResetarSenha'));
const InscricaoAdmin = lazy(() => import('./pages/Inscricao/InscricaoAdmin'));
const InscricaoAdminById = lazy(() => import('./pages/Inscricao/InscricaoAdminById'));
const InscricaoAdminAddEdital = lazy(() => import('./pages/Inscricao/InscricaoAdminAddEdital'));
const InscricaoAdminEditEdital = lazy(() => import('./pages/Inscricao/InscricaoAdminEditEdital'));
const InscricaoEsqueciSenhaOk = lazy(() => import('./pages/Inscricao/InscricaoEsqueciSenhaOk'));
const Docs = lazy(() => import('./pages/Docs'));
const MapaRede = lazy(() => import('./pages/Mapa/Rede'));
const MapaCapsAd = lazy(() => import('./pages/Mapa/CapsAd'));
const MapaCapsCasaDoLargo = lazy(() => import('./pages/Mapa/CapsCasaDoLargo'));
const MapaCapsHerbertDeSouza = lazy(() => import('./pages/Mapa/CapsHerbertDeSouza'));
const MapaCapsiMonteiroLobato = lazy(() => import('./pages/Mapa/CapsiMonteiroLobato'));
const MapaRaps = lazy(() => import('./pages/Mapa/Raps'));
const Bi = lazy(() => import('./pages/Bi'));
const AtivsEducativasList = lazy(() => import('./pages/AtivsEducativas/List'));
const AtivsEducativasForm = lazy(() => import('./pages/AtivsEducativas/Form'));
const GestaoDeLeitos = lazy(() => import('./pages/GestaoDeLeitos'));
const GestaoDeLeitosAdmin = lazy(() => import('./pages/GestaoDeLeitosAdmin'));
const GestaoDeLeitosRelatorios = lazy(() => import('./pages/GestaoDeLeitosRelatorios'));
const Logs = lazy(() => import('./pages/Admin/Logs'));

const Routes = () => {
  const { login } = useContext(UserContext);

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/esqueci-senha" component={EsqueciSenha} />
        <Route exact path="/senha-ok" component={EsqueciSenhaOk} />
        <Route exact path="/resetar-senha" component={ResetarSenha} />
        <Route exact path="/confirmacao" component={Confirmacao} />
        <Route exact path="/:capsUrl/validacao/:hash" component={DocValidation} />
        <Route exact path="/inscricao/:edital/resetar-senha" component={InscricaoResetarSenha} />
        <Route exact path="/inscricao/:edital/senha-ok" component={InscricaoEsqueciSenhaOk} />
        <Route exact path="/inscricao/:edital" component={InscricaoCadastro} />
        <Route exact path="/inscricao/:edital/esqueci-senha" component={InscricaoEsqueciSenha} />
        <Route exact path="/inscricao/:edital/login" component={InscricaoLogin} />
        <Route exact path="/inscricao/:edital/:_id" component={Inscricao} />
        <Route exact path="/mapa/rede" component={MapaRede} />
        <Route exact path="/pdf-teste" component={PDFView} />
        <Route exact path="/bi" component={Bi} />
        <ProtectedRoute exact path="/mapa/capsad" component={MapaCapsAd} />
        <ProtectedRoute exact path="/mapa/capscasadolargo" component={MapaCapsCasaDoLargo} />
        <ProtectedRoute exact path="/mapa/capsherbertdesouza" component={MapaCapsHerbertDeSouza} />
        <ProtectedRoute exact path="/mapa/capsimonteirolobato" component={MapaCapsiMonteiroLobato} />
        <ProtectedRoute exact path="/mapa/raps" component={MapaRaps} />
        <ProtectedRoute exact path="/docs/:diretoria/:setor" component={Docs} />
        <InscricaoAdminRoute exact path="/inscricao-admin" component={InscricaoAdmin} />
        <InscricaoAdminRoute exact path="/inscricao-admin/add-edital" component={InscricaoAdminAddEdital} />
        <InscricaoAdminRoute exact path="/inscricao-admin/edit-edital/:edital" component={InscricaoAdminEditEdital} />
        <InscricaoAdminRoute exact path="/inscricao-admin/:_id" component={InscricaoAdminById} />
        <PesquisaRoute exact path="/pesquisa-grafico" component={PesquisaGrafico} />
        <PesquisaRoute exact path="/pesquisa-graficos" component={PesquisaGraficos} />
        <Route exact path="/pesquisa/:cnes" component={Pesquisa} />
        <ProtectedRoute exact path="/solicitacoes" component={Chamados} />
        <ProtectedRoute exact path="/solicitacoes/novo" component={ChamadosNovo} />
        <ProtectedRoute exact path="/solicitacoes/graficos" component={Graficos} />
        <ProtectedRoute exact path="/solicitacao/:id" component={Chamado} />
        <OuvidoriaConsultaRoute exact path="/ouvidoria" component={Ouvidoria} />
        <OuvidoriaRoute exact path="/ouvidoria-add" component={OuvidoriaAdd} />
        <OuvidoriaRoute exact path="/ouvidoria/editar/:id" component={OuvidoriaEdit} />
        <OuvidoriaConsultaRoute exact path="/ouvidoria/show/:id" component={OuvidoriaShow} />
        <CipaRoute exact path="/cipaa/lista" component={CipaaList} />
        <ProtectedRoute exact path="/cipaa/apuracao" component={CipaaApuracao} />
        <ProtectedRoute exact path="/cipaa/apresentacao-candidatos" component={CipaaApresentacao} />
        <ProtectedRoute exact path="/cipaa/votacao" component={CipaaVotacao} />
        <AdminRoute exact path="/admin" component={Admin} />
        <AdminRoute exact path="/admin/usuarios" component={Usuarios} />
        <AdminRoute exact path="/admin/usuarios/novo" component={UsuariosNovo} />
        <AdminRoute exact path="/admin/usuarios/:id" component={UsuariosEditar} />
        <AdminRoute exact path="/admin/logs" component={Logs} />
        <VRVARoute exact path="/vrva" component={VRVA} />
        <VestuarioRoute exact path="/vestuario" component={Vestuario} />
        <ProtectedRoute exact path="/atividades-educativas">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <AtivsEducativasList />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </ProtectedRoute>
        <ProtectedRoute exact path="/atividades-educativas/show/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <AtivsEducativasForm type="show" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </ProtectedRoute>
        <ProtectedRoute exact path="/atividades-educativas/create">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <AtivsEducativasForm type="create" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </ProtectedRoute>
        <ProtectedRoute exact path="/atividades-educativas/edit/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <AtivsEducativasForm type="edit" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </ProtectedRoute>
        <CapsRoute exact path="/ceco">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <CCCNList />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/show/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <CCCNForm type="show" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/create">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <CCCNForm type="create" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/edit/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <CCCNForm type="edit" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/docs/:id/new">
          <CapsProvider>
            <CapsDocsProvider>
              <CCCNDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/docs/show/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CCCNDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/docs/edit/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CCCNDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/ceco/docs/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CCCNDocsList />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <GestaoDeLeitosRoute exact path="/gestao-leitos" component={GestaoDeLeitos} />
        <GestaoDeLeitosRoute exact path="/gestao-leitos-admin" component={GestaoDeLeitosAdmin} />
        <GestaoDeLeitosRoute exact path="/gestao-leitos-relatorios" component={GestaoDeLeitosRelatorios} />
        <CapsRoute exact path="/graficos-acao/pessoas-atendidas">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <PessoasAtendidas />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/atendimentos">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <Atendimentos />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/perfil-pop">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <PerfilPop />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/unidade-ref">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <UnidadeRef />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/acoes">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <AcoesRealizadas />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/encaminhamentos">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <Encaminhamentos />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/graficos-acao/demandas">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <Demandas />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais">
          <CapsProvider>
            <AcoesTerritoriaisProvider>
              <ReducaoTerritorio />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/mapa">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducaoDeDanos />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/:id/novo">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducaoForm type="create" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/:id/editar/:idUsuario">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducaoForm type="edit" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/novo">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <AcaoForm type="create" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/editar/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <AcaoForm type="edit" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/mapa-territorio/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducaoMapaTerritorio />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/usuario/:id/acoes">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <AcoesUsuario />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducoesList />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/:id">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <ReducaoList />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/:id/nova-atividade">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <NovaAcao type="new" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/acoes-territoriais/:territorio/:date/:id/excluir-atividade">
          <CapsProvider>
            <AcoesTerritoriaisProvider>         
              <NovaAcao type="delete" />
            </AcoesTerritoriaisProvider>
          </CapsProvider>
        </CapsRoute>

        <CapsRoute exact path="/caps">
          <CapsProvider>
            <Caps />
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/adicionar">
          <CapsProvider>
            <CapsAdd />
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/show/:id">
          <CapsProvider>
            <CapsShow />
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/editar/:id">
          <CapsProvider>
            <CapsEdit />
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/docs/:id/new">
          <CapsProvider>
            <CapsDocsProvider>
              <CapsDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/docs/show/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CapsDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/docs/edit/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CapsDocsForm />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/docs/:id">
          <CapsProvider>
            <CapsDocsProvider>
              <CapsDocs />
            </CapsDocsProvider>
          </CapsProvider>
        </CapsRoute>
        <CapsRoute exact path="/caps/mapa" component={CapsMapa} />
        <MetasRoute exact path="/metas" component={Metas} />
        <MetasRoute exact path="/metas/contrato-de-gestao/indicador1" component={GestaoIndicador1} />
        <MetasRoute exact path="/metas/contrato-de-gestao/indicador2" component={GestaoIndicador2} />
        <MdiRoute exact path="/monitoramento">
          <MonitoramentoProvider>
            <MonitoramentoList />
          </MonitoramentoProvider>
        </MdiRoute>
        <MdiRoute exact path="/monitoramento/show/:id">
          <MonitoramentoProvider>
            <MonitoramentoForm type="show" />
          </MonitoramentoProvider>
        </MdiRoute>
        <MdiRoute exact path="/monitoramento/adicionar">
          <MonitoramentoProvider>
            <MonitoramentoForm type="create" />
          </MonitoramentoProvider>
        </MdiRoute>
        <MdiRoute exact path="/monitoramento/editar/:id">
          <MonitoramentoProvider>
            <MonitoramentoForm type="edit" />
          </MonitoramentoProvider>
        </MdiRoute>
        <Route exact path="/login" component={Login}>
          {login && <Redirect to='/' />}
        </Route>
        <Route component={PageNotFound} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
